import { AnswerGroup } from 'app/shared/interfaces/AnswerGroup.interface';
import { Dictionary, DictionaryEntry } from 'app/services/dict.service';

export function useMultipleSelectGroups(
  options: Dictionary,
  answerGroups?: Array<AnswerGroup>
) {
  const getOptionWithGroupLabel = (option: DictionaryEntry) => {
    const answerGroup = answerGroups!.find(
      (group) => group.groupName === option.group
    );

    const groupLabel = answerGroup?.label || '';
    return {
      ...option,
      group: groupLabel,
    };
  };

  const groupBy = answerGroups
    ? (options: DictionaryEntry) => options.group || ''
    : undefined;

  const suggestions = answerGroups
    ? options.map(getOptionWithGroupLabel)
    : options;

  return {
    groupBy,
    suggestions,
  };
}
